// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"qj","header":"qk","headline":"ql","closeIcon":"qm","modalCloseIcon":"qn"};